import React from 'react';
import './Page.css';
import GalleryComponent from "../componetns/menu/gallery/GalleryComponent";
import CardVeryBig from "../componetns/card/CardVeryBig";

function Researches() {
    return (
        <div className="main_work_field">
            <GalleryComponent/>
            <CardVeryBig/>
        </div>
    );
}

export default Researches;